export default class ApplianceManufacturerEntity {

    constructor() {
        this.id = null
        this.name = ""
        this.active = false
    }

    /**
     * @param response : object
     * @returns ApplianceManufacturerEntity
     */
    static from(response) {

        let obj = new this
        obj.id = response.id
        obj.name = response.name
        obj.active = response.active
        return obj
    }

    to() {
        return this.id
    }

}
